export default {
  title: 'Gift List',
  addGift: 'Add Gift',
  editGift: 'Edit Gift',
  giftName: 'Gift Name',
  giftNo: 'Gift No.',
  giftType: 'Gift Type',
  giftCategory: 'Gift Category',
  virtualGift: 'Virtual Gift',
  physicalGift: 'Physical Gift',
  id: 'ID',
  giftInfo: 'Gift Info',
  giftPrice: 'Gift Price',
  giftSpec: 'Gift Spec',
  detail: 'Detail',
  singleSpec: 'Single Spec',
  multiSpec: 'Multi Spec',
};
